/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getTreatmentRadiations } from 'app/entities/treatment-radiation/treatment-radiation.reducer';
import { getEntities as getRadiationDosimetries } from 'app/entities/radiation-dosimetry/radiation-dosimetry.reducer';
import { createEntity, getEntity, reset, updateEntity } from './treatment-radiation-dosimetry.reducer';

export const TreatmentRadiationDosimetryUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const treatmentRadiations = useAppSelector(state => state.treatmentRadiation.entities);
  const radiationDosimetries = useAppSelector(state => state.radiationDosimetry.entities);
  const treatmentRadiationDosimetryEntity = useAppSelector(state => state.treatmentRadiationDosimetry.entity);
  const loading = useAppSelector(state => state.treatmentRadiationDosimetry.loading);
  const updating = useAppSelector(state => state.treatmentRadiationDosimetry.updating);
  const updateSuccess = useAppSelector(state => state.treatmentRadiationDosimetry.updateSuccess);

  const handleClose = () => {
    navigate(`/treatment-radiation-dosimetry${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getTreatmentRadiations({}));
    dispatch(getRadiationDosimetries({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...treatmentRadiationDosimetryEntity,
      ...values,
      radiationSession: treatmentRadiations.find(it => it.id.toString() === values.radiationSession?.toString()),
      dosimetry: radiationDosimetries.find(it => it.id.toString() === values.dosimetry?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...treatmentRadiationDosimetryEntity,
          radiationSession: treatmentRadiationDosimetryEntity?.radiationSession?.id,
          dosimetry: treatmentRadiationDosimetryEntity?.dosimetry?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2
            id="tinyMedicRestApp.treatmentRadiationDosimetry.home.createOrEditLabel"
            data-cy="TreatmentRadiationDosimetryCreateUpdateHeading"
          >
            <Translate contentKey="tinyMedicRestApp.treatmentRadiationDosimetry.home.createOrEditLabel">
              Create or edit a TreatmentRadiationDosimetry
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="treatment-radiation-dosimetry-id"
                  label={translate('tinyMedicRestApp.treatmentRadiationDosimetry.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentRadiationDosimetry.administeredDoseDistribution')}
                id="treatment-radiation-dosimetry-administeredDoseDistribution"
                name="administeredDoseDistribution"
                data-cy="administeredDoseDistribution"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentRadiationDosimetry.administeredDoseCalcAlgorithm')}
                id="treatment-radiation-dosimetry-administeredDoseCalcAlgorithm"
                name="administeredDoseCalcAlgorithm"
                data-cy="administeredDoseCalcAlgorithm"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentRadiationDosimetry.administeredDoseGrid')}
                id="treatment-radiation-dosimetry-administeredDoseGrid"
                name="administeredDoseGrid"
                data-cy="administeredDoseGrid"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentRadiationDosimetry.active')}
                id="treatment-radiation-dosimetry-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentRadiationDosimetry.cursor')}
                id="treatment-radiation-dosimetry-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentRadiationDosimetry.lastUpdated')}
                id="treatment-radiation-dosimetry-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentRadiationDosimetry.microSec')}
                id="treatment-radiation-dosimetry-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentRadiationDosimetry.timestampEntry')}
                id="treatment-radiation-dosimetry-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="treatment-radiation-dosimetry-radiationSession"
                name="radiationSession"
                data-cy="radiationSession"
                label={translate('tinyMedicRestApp.treatmentRadiationDosimetry.radiationSession')}
                type="select"
              >
                <option value="" key="0" />
                {treatmentRadiations
                  ? treatmentRadiations.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="treatment-radiation-dosimetry-dosimetry"
                name="dosimetry"
                data-cy="dosimetry"
                label={translate('tinyMedicRestApp.treatmentRadiationDosimetry.dosimetry')}
                type="select"
              >
                <option value="" key="0" />
                {radiationDosimetries
                  ? radiationDosimetries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/treatment-radiation-dosimetry"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default TreatmentRadiationDosimetryUpdate;
